<template>
  <div>
    <div
      :class="{
        ticket: !isDisabled,
        'ticket--inactive': isDisabled
      }"
    >
      <div class="ticket-box" @click="clickTicket">
        <span v-if="isTicketExpired" class="tag">期限切れ</span>
        <span v-else-if="isTicketSoldOut" class="tag">入荷待ち</span>
        <span class="ticket-image">
          <img :src="imageUrl" />
        </span>
        <div
          class="ticket-info"
          :class="{ 'ticket-giftee-asterisk': showableGifteeAsterisk }"
        >
          <p class="ticket__item-name">
            {{ itemName }}
          </p>
          <p v-if="isNotEmptyItemSkuName" class="ticket__item-min-unit">
            {{ itemSkuName }}
          </p>
          <p class="ticket__brand--small">
            {{ brandName }}
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="!isTicketExpired && isNotEmptyExprirationDate"
      class="ticket-expired-date"
    >
      <span class="ticket-expired-date__date">{{ expirationDate }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    // TODO: ↓名称をexpiredDateに変更する
    expirationDate: {
      type: String,
      required: false,
      default: ''
    },
    isTicketExpired: {
      type: Boolean,
      required: true
    },
    isTicketSoldOut: {
      type: Boolean,
      required: true
    },
    showableGifteeAsterisk: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isNotEmptyExprirationDate() {
      return this.expirationDate !== ''
    },
    isNotEmptyItemSkuName() {
      return this.itemSkuName !== ''
    },
    isDisabled() {
      return this.isTicketExpired || this.isTicketSoldOut
    }
  },
  methods: {
    clickTicket() {
      this.$emit('click-ticket')
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  font-size: 1.6rem;
  line-height: 1.6;
  color: $black;
  text-decoration: none;
  width: 100%;
  display: block;
  background-color: $white;
  border-radius: 8px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  &-box {
    height: 90px;
    display: flex;
  }

  &-image {
    height: 100%;
    font-size: 0;
  }

  &-image img {
    height: 100%;
  }

  &-info {
    overflow: hidden;
    width: 100%;
    padding: 16px;
  }

  &__item-name {
    font-weight: bold;
    font-size: 1.6rem;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 8px;
    color: $black;
  }

  &__item-min-unit {
    font-weight: bold;
    font-size: 1.4rem;
    line-height: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 12px;
    color: $black;
  }

  &__brand--small {
    font-size: 1.2rem;
    line-height: 1.6;
    color: $gray-1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    font-size: 1rem;
  }

  &-expired-date {
    padding-top: 4px;
    text-align: right;

    &__date {
      font-size: 1rem;
      line-height: 2;
      color: $gray-1;
      text-align: right;
    }
  }

  &-giftee-asterisk {
    @include bg-settings(
      '../../../../../images/giftee-asterisk.svg',
      $white,
      35px,
      35px
    );
    background-position: top right;
  }
}

.ticket--inactive {
  @extend .ticket;
  @extend %hover-common;
  pointer-events: none;
  position: relative;
  box-shadow: none;

  .ticket-box::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: $gray-2;
    opacity: 0.8;
    border-radius: 8px;
  }

  .ticket-box {
    position: relative;

    .tag {
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 8px 16px;
    }
  }
}
</style>
